"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var Placeholder = _styledComponents.default.div.withConfig({
  displayName: "PlaceholderItem__Placeholder",
  componentId: "sc-d8kim6-0"
})(["box-sizing:border-box;width:100%;padding:", " ", " ", " ", ";"], _styles.spacing.xs, _styles.spacing.m, _styles.spacing.xs, _styles.spacing.m);
var PlaceholderItem = function PlaceholderItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Placeholder, {
    children: children
  });
};
PlaceholderItem.defaultProps = {};
var _default = exports.default = PlaceholderItem;